import React, { Component, createRef } from 'react';
import { withTranslation } from 'react-i18next';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { isEmpty } from 'lodash-es';
import { FileInfo } from '@dev/ee-api/ee-api-models/file-info';
import { MediaManager } from '@dev/ee-modules';

import Auth from '@/services/Authentication';
import Loader from '@/services/PageLoader';
import { ApplicationState as State } from '@/store';
import { ShowToastParams } from '@/store/toast/types';
import { ShowDialogParams } from '@/store/dialog/types';
import { ShowToast } from '@/store/toast/actions';
import { HideDialog, ShowDialog } from '@/store/dialog/actions';
import { DeleteFile, DeleteFilesList, LoadUserFiles } from '@/store/userfiles/actions';

import { goBack, push } from 'redux-first-history';
import LayoutSrc from '../../services/Router/LegacyDashRoute/layout.html';

import { UploadFilesMedia as UploadFiles } from '../../store/upload/actions';
import {
    HideMediaManager,
    HideMediaManagerUploader,
    ShowFileUpload,
    ShowMediaManager,
    ShowMediaManagerUploader,
} from '../../store/mediaManager/actions';
import { FileType } from '../../store/mediaManager/types';
import { LegacyDDRouteType } from './EditorDDInterface';

type LegacyDDRouteStateType = {
    isLoading: boolean;
    disableRedirect: boolean;
    changeImageFunc?: any;
    imgToChange?: any;
    mediaManagerFileType?: string;
};

const CDN_PATH = LEGACY_EE_BUNDLE;

declare const window: any;
declare const ee: any;

const mapState = (state: State): LegacyDDRouteType => ({
    router: state.router,
    locationHistory: state.locationHistory,
    bootedAsChild: state.config.bootedAsChild,
    mediaManager: state.mediaManager,
    upload: state.upload,
    userFiles: state.userFiles,
    account: state.account,
    browser: state.browser,
    config: state.config,
});
const dispatchProps = {
    ShowMediaManager,
    HideMediaManager,
    UploadFiles,
    LoadUserFiles,
    DeleteFile,
    DeleteFilesList,
    ShowMediaManagerUploader,
    HideMediaManagerUploader,
    ShowFileUpload,
    ShowToast,
    HideDialog,
    ShowDialog,
    goBack,
    push,
};

interface DispatchProps {
    ShowMediaManager: () => void;
    HideMediaManager: () => void;
    UploadFiles(file: File): void;
    LoadUserFiles(): void;
    DeleteFile(name: string, imageDelete: boolean): void;
    DeleteFilesList(filesList: string[], imagesDelete: boolean): void;
    ShowMediaManagerUploader(): void;
    HideMediaManagerUploader(): void;
    ShowFileUpload(file: FileType): void;
    ShowToast(params: ShowToastParams): void;
    HideDialog: () => void;
    ShowDialog: (params: ShowDialogParams) => void;
    goBack: () => void;
    push: (url: string) => void;
}

type ExtendedProps = LegacyDDRouteType & DispatchProps;

class DragDropEditor extends Component<ExtendedProps, LegacyDDRouteStateType> {
    public constructor(props) {
        super(props);

        const bundlePath = `${CDN_PATH}/1.0/emailinterface.js`;
        const cssPath = `${CDN_PATH}/1.0/emailinterface.css"`;
        const apiPath = `${APIPATH}`;

        this.template = this.template.replace('{{BUNDLE_PATH}}', bundlePath);
        this.template = this.template.replace('{{CSS_PATH}}', cssPath);
        this.template = this.template.replace('{{apiPath}}', apiPath);
        this.template = this.template.replace("'{{bootedAsChild}}'", this.props.bootedAsChild as any);
        this.state = {
            isLoading: true,
            disableRedirect: true,
            mediaManagerFileType: 'files',
        };

        if (props?.locationHistory?.previousLocation?.pathname) {
            sessionStorage.setItem(
                'prevPath',
                `${props.locationHistory.previousLocation.pathname}${props.locationHistory.previousLocation.search}`
            );
        }
        window.document.addEventListener('navigateBack', this.navigateBack);
    }

    private iFrameRef = this.props.overwriteIframeRef || createRef<HTMLIFrameElement>();

    private timeoutId: any;

    private template = this.props.overwriteLayoutSrc || LayoutSrc;

    public componentDidUpdate(prevProps: any): void {
        if (this.props.overwritePath) {
            return;
        }

        if (prevProps.router.location.hash !== (this.props.router.location as any)?.hash) {
            // @ts-expect-error ee global object
            this.iFrameRef.current?.contentWindow?.window?.ee?.goTo?.(this.props.router.location.hash);
        }

        if (LEGACYDASHFROMLOCAL) {
            console.warn(
                'You have set LEGACYDASHFROMLOCAL in .env file, it will serve legacy dashboard from "/deploy/1.0/" files in your local machine. if you want to see any changes in legacy dashboard files you have to run "npm run build" or "npm run build-prod" after each change. Please note you can run it in seperate process and you DONT have to stop "run next-gen bundle" process'
            );
        }
    }

    public componentDidMount(): void {
        this.isLegacyDDLoaded();
    }

    public componentWillUnmount(): void {
        window.document.removeEventListener('navigateBack', this.navigateBack);
    }

    navigateBack = (e: CustomEvent<{ breadcrumbUrl: string }>): void => {
        const { goBack, push } = this.props;
        const url = e?.detail?.breadcrumbUrl;
        console.log('customevent');
        url ? push(url) : goBack();
        // goBack();
    };

    private isLegacyDDLoaded(): void {
        this.timeoutId = setTimeout(() => {
            sessionStorage.setItem('key', Auth.getAccessToken());
            const iFrameWindow = this.iFrameRef.current?.contentWindow?.window;
            if (!iFrameWindow) {
                return;
            }

            // @ts-expect-error ee global object
            if (iFrameWindow.ee && !isEmpty(iFrameWindow.ee.data) && !isEmpty(iFrameWindow.ee.data.account)) {
                clearTimeout(this.timeoutId);

                // @ts-expect-error ee global object
                iFrameWindow.ee.indiOn();

                if (this.props.overwritePath) {
                    // @ts-expect-error ee global object
                    iFrameWindow.ee?.goTo?.(this.props.overwritePath);
                }
                this.props.onloadCallback?.(iFrameWindow);
                setTimeout(() => {
                    // @ts-expect-error ee global object
                    iFrameWindow.ee.indiOff();
                }, 2000);

                this.setState({ isLoading: false });

                return;
            }

            this.isLegacyDDLoaded();
        }, 100);
    }

    private onFileSelected(file: FileInfo): void {
        const { account, HideMediaManager } = this.props;
        const { imgToChange, changeImageFunc } = this.state;

        const { PublicAccountID } = account.GeneralInfo;

        const fileToInsert = `${APIPATH}/userfile/${PublicAccountID}/${file.FileName}`;

        changeImageFunc(fileToInsert, imgToChange);
        HideMediaManager();
    }

    private openMediaManager(): void {
        const { ShowMediaManager } = this.props;

        ShowMediaManager();
    }

    private getApiPath = (): string => {
        if (!this.props.config.isStandalone && window.ee) {
            return ee.api.path;
        }

        return APIPATH;
    };

    private MediaManagerWithProps(): JSX.Element {
        const apiPath = this.getApiPath();

        return (
            <MediaManager
                onFileSelect={this.onFileSelected.bind(this)}
                account={this.props.account}
                browser={this.props.browser}
                upload={this.props.upload}
                userFiles={this.props.userFiles}
                mediaManager={this.props.mediaManager}
                APIPATH={apiPath}
                UploadFiles={this.props.UploadFiles}
                LoadUserFiles={this.props.LoadUserFiles}
                DeleteFile={this.props.DeleteFile}
                DeleteFilesList={this.props.DeleteFilesList}
                ShowDialog={this.props.ShowDialog}
                HideDialog={this.props.HideDialog}
                HideMediaManager={this.props.HideMediaManager}
                ShowMediaManagerUploader={this.props.ShowMediaManagerUploader}
                HideMediaManagerUploader={this.props.HideMediaManagerUploader}
                ShowFileUpload={this.props.ShowFileUpload}
                ShowToast={this.props.ShowToast}
                t={this.props.t}
                imageTabOnly={!!(this.state.mediaManagerFileType === 'images')}
            />
        );
    }

    private handleIframeLoad(): void {
        window.isNewDash = true;
        window.openMediaManager = (elementToChange, changeImageFunc, fileType) => {
            this.openMediaManager();
            this.setState({
                changeImageFunc,
                imgToChange: elementToChange,
                mediaManagerFileType: fileType,
            });
        };
    }

    public render(): JSX.Element {
        return (
            <>
                {this.state.isLoading && <Loader />}
                <iframe
                    ref={this.iFrameRef}
                    referrerPolicy="unsafe-url"
                    title="legacyDD"
                    srcDoc={this.template}
                    style={{
                        border: 'none',
                        height: this.props.overwriteHeight ?? '100vh',
                        display: 'block',
                    }}
                    width={'100%'}
                    onLoad={this.handleIframeLoad.bind(this)}
                />
                {this.props.mediaManager.isOpened && this.MediaManagerWithProps()}
            </>
        );
    }
}

export default compose(
    withTranslation(),
    connect<LegacyDDRouteType, DispatchProps>(mapState, dispatchProps)
)(DragDropEditor);
